import { render, staticRenderFns } from "./SupplierLogsTemplate.vue?vue&type=template&id=da638218&scoped=true&"
import script from "./SupplierLogsTemplate.vue?vue&type=script&lang=js&"
export * from "./SupplierLogsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SupplierLogsTemplate.vue?vue&type=style&index=0&id=da638218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da638218",
  null
  
)

export default component.exports